import { Chip, extendVariants } from '@heroui/react';

// Merged from frontend + frontend-ops; `completed` variant from frontend is kept.
const Tag = extendVariants(Chip, {
  variants: {
    color: {
      yellow: {
        base: ['bg-yellow-1 text-yellow-dark-2']
      },
      blue: {
        base: ['bg-cyan-light-3 text-cyan-dark']
      },
      dark_blue: {
        base: ['bg-[#DDDFFF] text-primary']
      },
      green: {
        base: ['text-green-dark bg-green-light-6']
      },
      'green-dark': {
        base: ['text-white bg-green-dark']
      },
      red: {
        base: ['text-red-9 bg-red-0']
      },
      default: {
        base: ['bg-gray-3 text-secondary-text']
      },
      none: {
        base: ['bg-transparent text-primary-text']
      },
      flat: {
        base: ['bg-violet-0 text-primary']
      },
      violet: {
        base: ['bg-[#F8F0FC] text-[#862E9C]']
      },
      purple: {
        base: ['bg-purple-light-4 text-purple-dark-2']
      },
      no_action: {
        base: ['bg-gray-2 text-secondary-text']
      },
      'in-progress': {
        base: ['bg-green-light-6 text-green-dark border border-green']
      },
      'action-required': {
        base: ['bg-red-1 text-red-9 border border-red-5']
      },
      'new-update': {
        base: ['bg-cyan-light-3 text-cyan-dark border border-cyan-light']
      },
      'user-question': {
        base: ['bg-yellow-light-3 text-yellow-dark-2 border border-yellow-dark']
      },
      action: {
        base: ['bg-red-1 text-red-9 border border-red-5']
      },
      'from-you': {
        base: ['bg-yellow-light-3 text-yellow-dark-2 border border-yellow-dark']
      },
      'from-user': {
        base: ['bg-yellow-light-3 text-yellow-dark-2 border border-yellow-dark']
      },
      resolved: {
        base: ['bg-green-light-6 text-green-dark border border-green']
      },
      completed: {
        base: ['bg-green-light-6 text-green-dark border border-green']
      },
      update: {
        base: ['bg-cyan-light-3 text-cyan-dark border border-cyan-light']
      }
    },
    size: {
      md: {
        base: ['font-medium rounded-lg h-[24px] px-0']
      }
    },
    radius: {
      full: {
        base: ['!rounded-full']
      }
    }
  },

  defaultVariants: {
    variant: 'solid',
    size: 'md',
    color: 'default'
  }
});

export default Tag;
